import { JustFonts } from './JustFonts';
export default JustFonts;
